(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eco-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eco-calculator')) {
    class EcoCalculator extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.fmt = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 });
        this.fmtEur = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
        this.onChange = this.update.bind(this);
        this.onCommit = this.track.bind(this);
        this.form.addEventListener('input', this.onChange);
        this.form.addEventListener('change', this.onChange);
        this.form.addEventListener('change', this.onCommit);
        const cta = this.out('cta');
        if (cta) cta.addEventListener('click', () => this.track('ecolena_calculadora_cta'));
        this.update();
      }

      track(name) {
        const event = typeof name === 'string' ? name : 'ecolena_calculadora';
        const payload = {
          superficie_m2: parseFloat(this.value('area')) || 0,
          zona: this.value('zone'),
          combustible: this.value('fuel'),
          consumo_kg: this.lastKg || 0
        };
        if (typeof window.ecoTrack === 'function') window.ecoTrack(event, payload);
      }

      disconnectedCallback() {
        if (!this.form) return;
        this.form.removeEventListener('input', this.onChange);
        this.form.removeEventListener('change', this.onChange);
        this.form.removeEventListener('change', this.onCommit);
      }

      value(name) {
        const el = this.form.querySelector(`[name="${name}"]:checked`) || this.form.querySelector(`[name="${name}"]`);
        return el ? el.value : null;
      }

      out(key) {
        return this.querySelector(`[data-out="${key}"]`);
      }

      update() {
        const d = this.dataset;
        const area = parseFloat(this.value('area')) || 90;
        const demand = { warm: parseFloat(d.demandWarm), mild: parseFloat(d.demandMild), cold: parseFloat(d.demandCold) }[this.value('zone')] || 75;
        const insulation = parseFloat(this.value('insulation')) || 1;
        const usage = parseFloat(this.value('usage')) || 1;
        const fuel = this.value('fuel');

        // Energía útil (kWh/temporada) = superficie × demanda × aislamiento × uso
        const kwh = area * demand * insulation * usage;
        // Poder calorífico (kWh/kg) × rendimiento del aparato
        const pci = fuel === 'pellets' ? 4.8 : 4.0;
        const efficiency = fuel === 'pellets' ? 0.88 : 0.72;
        const kg = kwh / (pci * efficiency);
        this.lastKg = Math.round(kg);

        this.out('area').textContent = area;
        this.out('kwh').textContent = `${this.fmt.format(Math.round(kwh / 10) * 10)} kWh`;
        this.out('kg').textContent = this.fmt.format(Math.round(kg / 10) * 10);

        let units;
        let cost;
        if (fuel === 'pellets') {
          const bags = Math.ceil(kg / 15);
          const pallets = kg / 1050;
          units = `${this.fmt.format(bags)} sacos de 15 kg (≈ ${pallets.toLocaleString('es-ES', { maximumFractionDigits: 1 })} palés)`;
          cost = bags * (parseFloat(d.pricePellets) / 100);
        } else {
          const bigBags = kg / 1000;
          units = `≈ ${bigBags.toLocaleString('es-ES', { maximumFractionDigits: 1 })} sacas de 1.000 kg`;
          cost = kg * (parseFloat(d.priceLena) / 100);
        }
        this.out('units').textContent = units;

        const costRow = this.querySelector('[data-row="cost"]');
        if (d.showCost === 'true' && isFinite(cost) && cost > 0) {
          costRow.hidden = false;
          const low = Math.round((cost * 0.9) / 10) * 10;
          const high = Math.round((cost * 1.1) / 10) * 10;
          this.out('cost').textContent = `${this.fmtEur.format(low)} – ${this.fmtEur.format(high)}`;
        } else {
          costRow.hidden = true;
        }

        const cta = this.out('cta');
        cta.href = fuel === 'pellets' ? d.urlPellets : d.urlLena;
        cta.textContent = fuel === 'pellets' ? d.labelPellets : d.labelLena;
      }
    }
    customElements.define('eco-calculator', EcoCalculator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
